import { useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { TabsUI, FormLabelUI, FormErrorUI, InputUI } from '../Interface';
import ServiceOperationMaterial from './ServiceOperationMaterial';
import ServiceOperationCheckList from './ServiceOperationCheckList';
import ServiceGroupLinks from './ServiceGroupLinks';

const DescriptionPanel = (props) => {
  const { disabled } = props;
  const { values, errors } = useFormikContext();
  return (
    <div className="col-span-full relative">
      <Field
        type="text"
        name="note"
        as={InputUI}
        className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
        fullWidth
        label={<FormLabelUI text="Leírás" />}
        variant="standard"
        helperText={<FormErrorUI message={errors.note} />}
        disabled={disabled}
        InputLabelProps={{ shrink: values.note && values.note !== '' }}
        multiline
        rows={4}
      />
    </div>
  );
};

const ServiceOperationTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Megjegyzés',
      content: <DescriptionPanel {...props} />,
    },
    {
      id: 1,
      name: 'Alapanyag',
      content: <ServiceOperationMaterial {...props} />,
    },
    {
      id: 2,
      name: 'Checklista',
      content: <ServiceOperationCheckList {...props} />,
    },
    {
      id: 3,
      name: 'Csoportok',
      content: <ServiceGroupLinks {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default ServiceOperationTabs;
